var map = {
	"./1.jpg": 4157,
	"./2.jpg": 1874,
	"./3.jpg": 9935,
	"./4.jpg": 2148,
	"./5.jpg": 6481,
	"./6.jpg": 8726,
	"./7.jpg": 8211,
	"./mainImg.jpg": 4544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5135;